<template>
	 <div>
	 <div class="wrap" v-if="isMobile">
		 <div class="mexamination" v-if="returnCode==1">
			<h2>游戏代练师技能认定线上考试</h2>
			<div class="info" > <ul><li>考生姓名：<span>{{name}}</span></li><li>考试开始时间：<span>{{startDate}}</span></li></ul></div>
			<div class="djs">倒计时：{{remainingTime}}</div>
			<div class="questioncount">
				<template v-if="type1>0 && type2>0 && type3>0">
					单选题：{{type1}}道 多选题：{{type2}}道 判断题：{{type3}}道
				</template>
				<template v-else-if="type1==0 && type2>0 && type3>0">
					多选题：{{type2}}道 判断题：{{type3}}道
				</template>	
				<template v-else-if="type1>0 && type2==0 && type3>0">
					单选题：{{type1}}道 判断题：{{type3}}道
				</template>	
				<template v-else-if="type1>0 && type2>0 && type3==0">
					单选题：{{type1}}道 多选题：{{type2}}道 
				</template>	
			</div>
			<div class="clear"></div>

			<div class="subject" >
				<h3><em>{{index+1}}. </em>{{title}}</h3>
				
				 <div class="subject-item">
					<template v-if="type==1 || type==3"> 
						<el-radio-group v-model="radio1">
							<el-radio label="A" v-if="A && A!=''">A、{{A}}</el-radio>
							<el-radio label="B" v-if="B && B!=''">B、{{B}}</el-radio>
							<el-radio label="C" v-if="C && C!=''">C、{{C}}</el-radio>
							<el-radio label="D" v-if="D && D!=''">D、{{D}}</el-radio>
						</el-radio-group>
					</template>
					<template v-else-if="type==2">
						<el-checkbox-group v-model="checkList">
							<el-checkbox label="A" v-if="A!=''">A、{{A}}</el-checkbox>
							<el-checkbox label="B" v-if="B!=''">B、{{B}}</el-checkbox>
							<el-checkbox label="C" v-if="C!=''">C、{{C}}</el-checkbox>
							<el-checkbox label="D" v-if="D!=''">D、{{D}}</el-checkbox>
						</el-checkbox-group>
					</template>
				 </div>

				<div class="btn-subject">
					<el-button size="small" @click="prev()">上一题</el-button>
					<template v-if="(index+1)==examCount">
						<el-button size="small" type="primary" @click="submit()" >提 交</el-button>
					</template>
					<template v-else>
						<el-button size="small" type="primary" @click="next()" >下一题</el-button>
					</template>
				</div>
			</div>
			
        </div>
	 </div>
	 <div class="content" v-else>
        <div class="examination" v-if="returnCode==1">
			<h2>游戏代练师技能认定线上考试</h2>
			<div class="info" > <ul><li>考生姓名：<span>{{name}}</span></li><li>考试开始时间：<span>{{startDate}}</span></li></ul></div>
			<div class="clear"></div>

			<div class="subject fl" >
				<h3><em>{{index+1}}. </em>{{title}}</h3>
				
				 <div class="subject-item">
					<template v-if="type==1 || type==3"> 
						<el-radio-group v-model="radio1">
							<el-radio label="A" v-if="A && A!=''">A、{{A}}</el-radio>
							<el-radio label="B" v-if="B && B!=''">B、{{B}}</el-radio>
							<el-radio label="C" v-if="C && C!=''">C、{{C}}</el-radio>
							<el-radio label="D" v-if="D && D!=''">D、{{D}}</el-radio>
						</el-radio-group>
					</template>
					<template v-else-if="type==2">
						<el-checkbox-group v-model="checkList">
							<el-checkbox label="A" v-if="A!=''">A、{{A}}</el-checkbox>
							<el-checkbox label="B" v-if="B!=''">B、{{B}}</el-checkbox>
							<el-checkbox label="C" v-if="C!=''">C、{{C}}</el-checkbox>
							<el-checkbox label="D" v-if="D!=''">D、{{D}}</el-checkbox>
						</el-checkbox-group>
					</template>
				 </div>

				<div class="btn-subject">
					<el-button size="small" @click="prev()">上一题</el-button>
					<template v-if="(index+1)==examCount">
						<el-button size="small" type="primary" @click="submit()" >提 交</el-button>
					</template>
					<template v-else>
						<el-button size="small" type="primary" @click="next()" >下一题</el-button>
					</template>
				</div>
			</div>
			<div class="process fr" >
				<div class="circle">
					<el-progress type="circle" :percentage="percentage" :show-text="false" :width="100"></el-progress>
					<div class="dttime"><span>{{examCount}}题</span>{{remainingTime}}</div>
				</div>
				
				<template v-if="type1>0 && type2>0 && type3>0">
				<el-steps direction="vertical" :active="active" process-status="finish" finish-status="success"  :space="80">
					<el-step  :title="typeStr1"></el-step>
					<el-step  :title="typeStr2"></el-step>
					<el-step  :title="typeStr3"></el-step>
				</el-steps>
				</template>
				<template v-else-if="type1==0 && type2>0 && type3>0">
					<el-steps direction="vertical" :active="active" process-status="finish" finish-status="success"  :space="80">
					<el-step  :title="typeStr2"></el-step>
					<el-step  :title="typeStr3"></el-step>
					</el-steps>
				</template>	
				<template v-else-if="type1>0 && type2==0 && type3>0">
					<el-steps direction="vertical" :active="active" process-status="finish" finish-status="success"  :space="80">
					<el-step  :title="typeStr1"></el-step>
					<el-step  :title="typeStr3"></el-step>
					</el-steps>
				</template>	
				<template v-else-if="type1>0 && type2>0 && type3==0">
					<el-steps direction="vertical" :active="active" process-status="finish" finish-status="success"  :space="80">
					<el-step  :title="typeStr1"></el-step>
					<el-step  :title="typeStr2"></el-step>
					</el-steps>
				</template>	
			</div>
        </div>
	</div>
	</div>
</template>
<style scoped>
.examination { margin:16px 0;  background:#fff;overflow: hidden; font-size:14px; padding-bottom: 54px; }
.examination h2{ height:84px; line-height:84px; font-size:24px;  border-bottom:solid 1px #e8e8e8; color:#272727; font-weight:normal;text-align: center; }
.examination .info ul{margin:24px 5% 0; font-size:14px; overflow: hidden;}
.examination .info li{float: left; padding-right: 100px;}
.examination .info li span{color:#111; font-size: 16px;}
.examination h3{ font-weight: normal;margin:54px 0; max-width: 620px;}
.examination h3 em{font-weight: bold;}
.examination .subject{margin:0 5%;}
.examination .subject ul{margin:0 5%;overflow: hidden;}
.examination .subject .subject-item{margin:0 5%;}
.examination .subject li{ margin-bottom:30px;}
.examination .btn-subject{text-align: center; margin-top: 24px;}
.examination .process{margin-right:5%; font-size:14px; }
.examination .process .dttime{position:absolute;}
.examination .process .circle{margin-bottom: 54px;position: relative; }
.examination .dttime {text-align: center; top:31%;left:23%;}
.examination .dttime span{display: block; padding-bottom: 2px;}

.mexamination { margin:0.8rem 0;  background:#fff;overflow: hidden; font-size:0.7rem; padding-bottom:2.5rem; }
.mexamination h2{height:5rem; line-height:5rem; font-size:1.4rem;  border-bottom:solid 1px #e8e8e8; color:#272727; font-weight:normal;  text-align: center;margin-bottom: 1.2rem;}
.mexamination .info ul{margin:1.2rem 5% 0; font-size:1.2rem; overflow: hidden;}
.mexamination .info li{ margin-bottom:1rem;}
.mexamination .info li span{color:#111; }
.mexamination h3{ font-weight:normal;margin:2.5rem 0; font-size: 1.4rem; }
.mexamination h3 em{font-weight: bold;}
.mexamination .subject{margin:0 5%;}
.mexamination .subject ul{overflow: hidden;}
.mexamination .subject .subject-item{margin:0 5%;}
.mexamination .subject li{ margin-bottom:1.5rem;}
.mexamination .btn-subject{text-align: center; margin-top:1.2rem;}
.mexamination .process{margin-right:5%; font-size:0.7rem; }
.mexamination .process .dttime{position:absolute;}
.mexamination .process .circle{margin-bottom:2.5rem;position: relative; }
.mexamination .dttime {text-align: center; top:31%;left:23%;}
.mexamination .dttime span{display: block; padding-bottom: 2px;}
.mexamination .djs{ font-size:1.2rem; margin-left:5%; }
.mexamination .questioncount{font-size: 1.2rem;margin-left:5%;margin-top:1rem;}

</style>
<script>   
	export default {
		name: 'examination',
		methods: {
			getQuestions(){
				const self = this;
				var data= self.common.GetlocalStorage("UnLockUserData");
				var userId=JSON.parse(data).UserID;
				const loading = this.$loading(this.loading);
				self.http.ajaxGet("GetQuestions?UserID="+userId,function(res){
				loading.close();
				self.returnCode=res.ReturnCode;
                if(res.ReturnCode == 1){
					self.name=res.Result[0].Name;
					self.startDate=self.formatDate(res.Result[0].StartDate);
					self.examCount=res.Result[0].Type1+res.Result[0].Type2+res.Result[0].Type3;
					self.sepTime=res.Result[0].Countdown;
					self.seconds=res.Result[0].Seconds;
					self.typeId=res.Result[0].TypeID;
					self.result1Arr=res.Result1;
					self.type1=res.Result[0].Type1;
					self.type2=res.Result[0].Type2;
					self.type3=res.Result[0].Type3;
					self.typeStr1="1 ("+res.Result[0].Type1+"题)";
					self.typeStr2="2 ("+res.Result[0].Type2+"题)";
					self.typeStr3="3 ("+res.Result[0].Type3+"题)";

					//初始化一下答到第几题了
					for(var i=0;i<self.result1Arr.length;i++){
						if(self.result1Arr[i].Answer){
							self.index=i+1;
						}
					}

					self.fuzhi();
					self.beginTimer();
                }else{
					if(self.isMobile){
						self.$alert(res.Message, '', {
						confirmButtonText: '确定',
						customClass:'mfuli-message-box',
						type:"info",
						showClose:false,
						callback: action => {
							if(res.ReturnCode==-2){
								self.$router.push({path:'/sign-up'});
							}
							else if(res.ReturnCode==-5){
								self.$router.push({path:'/exam-result'});
							}
							else{
								self.$router.push({path:'/home'});
							}
						}
						});
					}else{
						self.$alert(res.Message, '', {
						confirmButtonText: '确定',
						type:"info",
						showClose:false,
						callback: action => {
							if(res.ReturnCode==-2){
								self.$router.push({path:'/sign-up'});
							}
							else if(res.ReturnCode==-5){
								self.$router.push({path:'/exam-result'});
							}
							else{
								self.$router.push({path:'/home'});
							}
						}
						});
					}
                }	
                },function(err){
					loading.close();
                    self.$alert(err, '错误', {confirmButtonText: '确定'});
                })
			},
			countDown(){
				//倒计时
				var ss=0;
				if(this.seconds>0){
					var lefttime = this.seconds ;  //距离结束时间的毫秒数
					var hour = Math.floor(lefttime/(1000*60*60)%60);         //计算小时数
					if(hour.toString().length==1)
						hour="0"+hour;

					var leftm = Math.floor(lefttime/(1000*60)%60);  	   //计算分钟数
					if(leftm.toString().length==1)
						leftm="0"+leftm;
					var lefts = Math.floor(lefttime/1000%60);  //计算秒数
					if(lefts.toString().length==1)
						lefts="0"+lefts;
					ss =  hour+ ":" + leftm + ":" + lefts;

					this.seconds=parseInt(this.seconds)-1000;
				}
				return ss;
			},
			beginTimer() { 
				var self=this;
				this.ticker = setInterval(() => {
					self.remainingTime=self.countDown();
					if(self.remainingTime==0){
						self.answerOver();
						clearInterval(self.ticker);
					}
				}, 1000);
			},
			handleCurrentChange(val){
				this.pageIndex=val;
			    this.list();
			},
			formatDate(date){
				return this.http.dateFormat1("yyyy-MM-dd hh:mm:ss",date);
			},
			prev(){
				if(this.type==1 || this.type==3){
					if(this.radio1!=''){
						this.result1Arr[this.index].Answer=this.radio1;
					}
				}else if(this.type==2){
					if(this.checkList.length>0){
						this.result1Arr[this.index].Answer=this.checkList.join(",");
					}
				}

				if(this.index>0){
					this.radio1='';
					this.checkList=[];
					this.index=this.index-1;
					this.fuzhi();
				}
			},
			next(){
				if(this.type==1 || this.type==3){
					if(this.radio1==''){
						this.$message({message: "请选择您的答案", type: 'warning'});  
						return;
					}else{
						this.submitOne(this.radio1);
						//this.result1Arr[this.index].Answer=this.radio1;
					}
				}else if(this.type==2){
					if(this.checkList.length==0){
						this.$message({message: "请选择您的答案", type: 'warning'});  
						return;
					}else if(this.checkList.length==1){
						this.$message({message: "此题目是多选，请选择多个答案", type: 'warning'});  
						return;
					}
					else{
						this.submitOne(this.checkList.join(","));
						//this.result1Arr[this.index].Answer=this.checkList.join(",");
					}
				}
			},
			fuzhi(){
				this.title=this.result1Arr[this.index].Title;
				this.A=this.result1Arr[this.index].A;
				this.B=this.result1Arr[this.index].B;
				this.C=this.result1Arr[this.index].C;
				this.D=this.result1Arr[this.index].D;
				this.type=this.result1Arr[this.index].Type;
				this.percentage= (this.index+1)/this.examCount*100;

				if(this.result1Arr[this.index].Answer){
					if(this.type==1 || this.type==3){
						this.radio1=this.result1Arr[this.index].Answer;
					}
					else{
						var words = this.result1Arr[this.index].Answer.split(',');
						for(var i=0;i<words.length;i++){
							this.checkList.push(words[i]);
						}
					}	
				}

				if(this.index>=(this.type1+this.type2)){
					this.active=2;
				}
				else if(this.index>=this.type1){
					this.active=1;
				} 
				
			},
			submitOne(answer){
				//提交一个答题
				const self = this;
				const loading = this.$loading(this.loading);
				var data= self.common.GetlocalStorage("UnLockUserData");
				var userId=JSON.parse(data).UserID;
				self.http.ajaxGet("UpdateAnswer?UserID="+userId+"&QuestionsID="+this.result1Arr[this.index].ID+"&Answer="+answer,function(res){
					loading.close();
					if(res.ReturnCode==1 && res.Result==1){
						self.result1Arr[self.index].Answer=answer;
						self.radio1='';
						self.checkList=[];
						self.index=self.index+1;
						self.fuzhi();
					}
					},function(err){
						loading.close();
						self.$alert(err, '提交答题错误', {confirmButtonText: '确定'});
				})
			},
			submit(){
				var answer='A';
				if(this.type==1 || this.type==3){
					if(this.radio1==''){
						this.$message({message: "请选择您的答案", type: 'warning'});  
						return;
					}else{
						answer=this.radio1;
						this.result1Arr[this.index].Answer=this.radio1;
					}
				}else if(this.type==2){
					if(this.checkList.length==0){
						this.$message({message: "请选择您的答案", type: 'warning'});  
						return;
					}
					else if(this.checkList.length==1){
						this.$message({message: "此题目是多选，请选择多个答案", type: 'warning'});  
						return;
					}
					else{
						answer=this.checkList.join(",");
						this.result1Arr[this.index].Answer=this.checkList.join(",");
					}
				}

				// var self=this;
				// const loading = this.$loading(this.loading);
				// var json={"list":this.result1Arr,"Type1":this.type1,"Type2":this.type2,"Type3":this.type3,"TypeID":this.typeId }
				// this.http.ajaxPost('SubmitQuestion',json,"",function(data){
				// 	loading.close();
				// 	if(data.ReturnCode == 1){
				// 		self.returnCode=-1;
				// 		self.$router.push({path:'/exam-result'});
				// 	}else{
				// 		self.$alert(data.Message, '温馨提示', {confirmButtonText: '确定'});
				// 	}
				// },function(res){ loading.close();self.$alert(res, '错误', {confirmButtonText: '确定'});});

				const self = this;
				const loading = this.$loading(this.loading);
				var data= self.common.GetlocalStorage("UnLockUserData");
				var userId=JSON.parse(data).UserID;

				self.http.ajaxGet("UpdateAnswer?UserID="+userId+"&QuestionsID="+this.result1Arr[this.index].ID+"&Answer="+answer,function(res){
					if(res.ReturnCode==1 && res.Result==1){
						self.answerOver();
					}
					},function(err){
						loading.close();
						self.$alert(err, '提交答题错误', {confirmButtonText: '确定'});
				})
			},
			answerOver(){
				//提交答案
				const self = this;
				const loading = this.$loading(this.loading);
				var data= self.common.GetlocalStorage("UnLockUserData");
				var userId=JSON.parse(data).UserID;
				self.http.ajaxGet("SubmitAnswer?UserID="+userId+"&TotalCount="+self.examCount,function(data){
					loading.close();
					if(data.ReturnCode == 1){
						self.returnCode=-1;
						self.$router.push({path:'/exam-result'});
					}else{
						if(self.isMobile){
							self.$alert(data.Message, '温馨提示', {confirmButtonText: '确定',customClass:'mfuli-message-box'});
						}else{
							self.$alert(data.Message, '温馨提示', {confirmButtonText: '确定'});
						}
					}
				},function(err){
					loading.close();
					self.$alert(err, '提交答题错误', {confirmButtonText: '确定'});
				})
			}
		},
		data() {
			return {
				name:'zhangsan',          							//考生姓名
				startDate:'2020-02-13 11:00:00',                    //开始时间
				percentage:1,             						    //进度条          
				examCount:100,                                      //考试题目
				remainingTime:'',                           		//剩余时间
				radio1:'',
				checkList: [],
				sepTime:90,                                         //考试时间
				seconds:0,                                         //倒计时剩余毫秒数
				typeId:1,
				type1:0,
				type2:0,
				type3:0,
				typeStr1:'',
				typeStr2:'',
				typeStr3:'',
				ticker:'',
				result1Arr:[],                                       //获取的题目
				index:0,                                             //做到第几题
				title:'',
				A:'',
				B:'',
				C:'',
				D:'',
				type:1,
				returnCode:-1,
				active:0
			}
		},
		computed:{
			loading(){
				return this.$store.getters.loadingPara;
			},
			isMobile(){
				return this.common.isMobile();
			}
		},
		mounted: function () {
			if(this.ticker) clearInterval(this.ticker);
			this.getQuestions();
		},
		beforeDestroy() {
			if(this.ticker) clearInterval(this.ticker);
			
		},
		beforeRouteLeave (to, from, next) {
			if(this.returnCode==1){
				if(this.isMobile){
					this.$confirm('确定要离开此次答题吗?', '提示', {
					confirmButtonText: '确定',
					customClass:'mfuli-message-box',
					cancelButtonText: '取消',
					type: 'warning'
					}).then(() => {
						next();
					}).catch(() => {
						next(false);
					});
				}else{
					this.$confirm('确定要离开此次答题吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
					}).then(() => {
						next();
					}).catch(() => {
						next(false);
					});
				}
			}else{
				next();
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/examination.vue